import React from 'react';
import { Typography } from '@/UIlibrary/Typography/Typography';
import { useTranslations } from 'use-intl';
import BureauAuthorizationsTable from '@/pages/Onboarding/BureauAuthorizations/BureauAuthorizationsTable';

const BureauAuthorizations: React.FC = () => {
	const t = useTranslations('BureauAuthorizations');

	return (
		<main className="p-3 md:p-8">
			<div className="flex flex-col gap-6">
				<Typography type="display">{t('BureauAuthorizations')}</Typography>
				<Typography size="xl">{t('Title')}</Typography>
				<BureauAuthorizationsTable />
			</div>
		</main>
	);
};

export default BureauAuthorizations;
